import { defineMessages, IntlShape } from 'react-intl'

import { MESSAGE_AUTHOR_TYPE } from '../../models/messages/Messages'

export type CoveringProviderActor =
  | {
      id?: string
      first_name?: string
      last_name?: string
    }
  | null
  | undefined

export const coveringProviderAttributionMessages = defineMessages({
  attribution: {
    defaultMessage: '{actorName} on the Lyra team',
    description: 'Attribution shown on messages sent by a supervisor while acting for a provider',
  },
  composerNotice: {
    defaultMessage: 'Messages will appear with “{attribution}”',
    description: 'Notice shown before a supervisor sends a message while acting for a provider',
  },
})

export const getCoveringProviderActorName = (
  actor: CoveringProviderActor,
  effectiveProviderId: string,
): string | null => {
  if (!actor?.id || actor.id === effectiveProviderId) {
    return null
  }

  const actorName = [actor.first_name, actor.last_name].filter(Boolean).join(' ').trim()
  return actorName || null
}

export const formatCoveringProviderAttribution = (intl: IntlShape, actorName: string): string =>
  intl.formatMessage(coveringProviderAttributionMessages.attribution, { actorName })

export const formatPersistedCoveringProviderAttribution = (
  intl: IntlShape,
  persistedActorName: unknown,
): string | undefined => {
  if (typeof persistedActorName !== 'string') {
    return undefined
  }

  const actorName = persistedActorName.trim()
  return actorName ? formatCoveringProviderAttribution(intl, actorName) : undefined
}

export const getMessageAuthorAttribution = (
  intl: IntlShape,
  attributes: { author_type?: string | null; metadata?: { covering_provider_actor_name?: unknown } },
  isEnabled: boolean,
): string | undefined =>
  attributes.author_type !== MESSAGE_AUTHOR_TYPE.PROVIDER || !isEnabled
    ? undefined
    : formatPersistedCoveringProviderAttribution(intl, attributes.metadata?.covering_provider_actor_name)

export const formatCoveringProviderComposerNotice = (intl: IntlShape, actorName: string): string =>
  intl.formatMessage(coveringProviderAttributionMessages.composerNotice, {
    attribution: formatCoveringProviderAttribution(intl, actorName),
  })
